// 支払通知書の宛名（本城さん依頼 #30）。
//
// もともとICB側で管理していたマスターB列「所属」(org) に、通知書の宛先として使う名前
// （多くは委託元の会社名）が入っている。所属があればそれを宛名にし、無ければ氏名にフォールバックする。
// 敬称は、会社・団体らしき名称なら「御中」、個人名・氏名フォールバック時は「様」。
//   例（本城さん見本）: 所属="有限会社熊野工業" → 「有限会社熊野工業 御中」
//
// ※ 御中/様の自動判定はヒューリスティック。所属に個人名が入る運用が判明したら見直す。

export type Recipient = { name: string; honorific: "御中" | "様"; usedOrg: boolean };

// 会社・団体らしき名称か（御中判定）。代表的な法人格・業種語を含むかで判定する。
export function looksLikeCompany(name: string): boolean {
  const s = name.trim();
  if (!s) return false;
  return (
    /(株式会社|有限会社|合同会社|合名会社|合資会社|相互会社|協同組合|有限責任事業組合|一般社団法人|公益社団法人|一般財団法人|公益財団法人|特定非営利活動法人)/.test(s) ||
    /(商会|商店|工業|産業|運送|運輸|物流|興業|建設|製作所|事務所|組合)/.test(s) ||
    /(㈱|㈲|\(株\)|（株）|\(有\)|（有）)/.test(s) ||
    /\b(Co\.?,?\s*Ltd\.?|Inc\.?|LLC|L\.?L\.?C\.?|Corp\.?|Company)\b/i.test(s)
  );
}

// 通知書の宛名を決める。org 優先・氏名フォールバック。会社らしければ御中、それ以外は様。
// 「個人」は所属名ではなくマスターの区分値 → 氏名宛にする（本城さん指示 6/19:
// 所属に社名がある方のみ社名表示、「個人」と記載の方は氏名表示）。
export function noticeRecipient(org: string | null | undefined, driverName: string): Recipient {
  const o = (org ?? "").trim();
  if (!o || o === "個人") return { name: driverName, honorific: "様", usedOrg: false };
  return { name: o, honorific: looksLikeCompany(o) ? "御中" : "様", usedOrg: true };
}

// 通知書に出す「受取側の登録番号」（本城さん要望 2026-08-07。MF請求書と同じく宛名の直下に出す）。
// 適格請求書発行事業者の登録番号（T＋13桁）の形をしているものだけ表示する:
//   - 未登録の方は null（行ごと出さない。値引きの説明は備考に入る）
//   - グループ宛通知書はインボイス値引きを抑止するためダミー "GROUP" を持つので、
//     形式で弾かないとお客様の通知書に「登録番号：GROUP」と出てしまう
export function displayInvoiceNo(invoiceNo: string | null | undefined): string | null {
  const v = (invoiceNo || "").trim();
  return /^T\d{13}$/.test(v) ? v : null;
}
